/* eslint-disable react-hooks/exhaustive-deps */
import Big from 'big.js';

import {
  getAmountPrice,
  getHumanReadableAmount,
  getMaxDecimalsReadable,
  shortenAddress,
} from 'utils/utils';
import { AssetQuantity } from 'components/ui/molecule/AssetQuantity';
import { PopperTooltip } from 'components/ui/molecule/PopperTooltip';
import {
  AddressDiv,
  ButtonStyled,
  CurrencyAmount,
  LeftSummary,
  RightSummary,
  Summary,
  ToDiv,
  TotalAmount,
  USDAmount,
  EstimatedFeesTooltip,
  AlertTotalExceedsAmount,
  LoadingWrapper,
} from './SendSummaryModal.style';
import { Modal } from 'components/ui/atom/Modal';
import { useAppSelector } from 'hooks/redux';
import { useEffect, useState } from 'react';
import { useMultiLanguage, useStarkNetSnap } from 'services';
import Toastr from 'toastr2';
import { FeeToken, FeeEstimate } from 'types';
import { useCurrentAccount } from 'hooks';

interface Props {
  address: string;
  amount: string;
  chainId: string;
  memo: string;
  closeModal?: () => void;
  handleBack: () => void;
  selectedFeeToken: FeeToken;
  gasFees: FeeEstimate;
  isEstimatingGas: boolean;
}

export const SendSummaryModalView = ({
  address,
  amount,
  chainId,
  memo,
  closeModal,
  handleBack,
  selectedFeeToken,
  gasFees,
  isEstimatingGas,
}: Props) => {
  const { address: currentAddress } = useCurrentAccount();
  const erc20TokenBalances = useAppSelector(
    (state) => state.wallet.erc20TokenBalances,
  );
  const erc20TokenBalanceSelected = useAppSelector(
    (state) => state.wallet.erc20TokenBalanceSelected,
  );
  const [gasFeesAmount, setGasFeesAmount] = useState('');
  const [gasFeesAmountUSD, setGasFeesAmountUSD] = useState('');
  const [amountUsdPrice, setAmountUsdPrice] = useState('');
  const [totalAmount, setTotalAmount] = useState('');
  const [totalAmountUSD, setTotalAmountUSD] = useState('');
  const [totalExceedsBalance, setTotalExceedsBalance] = useState(false);
  const { sendTransaction, getTransactions, createTransfer } =
    useStarkNetSnap();
  const { translate } = useMultiLanguage();
  const ethToken = erc20TokenBalances[0];
  const feeToken =
    erc20TokenBalances.find((token) => token.symbol === selectedFeeToken) ??
    ethToken;

  const toastr = new Toastr({
    closeDuration: 10000000,
    showDuration: 1000000000,
    positionClass: 'toast-top-center',
  });

  useEffect(() => {
    console.log('gasFees changed:', gasFees);
    if (gasFees?.fee) {
      const gasFeesBN = Big(gasFees.fee);
      let totalToCheck = gasFeesBN;

      console.log('feeToken', feeToken);

      const gasFeesStr = gasFees.fee;
      console.log('gasFeesStr', gasFeesStr);
      const gasFeesFloat = parseFloat(gasFeesStr);
      console.log('gasFeesFloat', gasFeesFloat);
      setGasFeesAmount(getMaxDecimalsReadable(feeToken, gasFeesStr));
      if (feeToken.usdPrice) {
        setGasFeesAmountUSD(getAmountPrice(feeToken, gasFeesFloat, false));
      }
      const amountBN = Big(amount);
      // Combine the transaction amount and fee amount if they are the same token.
      // And verify if the combined amount is not exceeding the total balance.
      if (
        erc20TokenBalanceSelected.instrumentAdmin === feeToken.instrumentAdmin
      ) {
        const totalAmountBN = gasFeesBN.add(amountBN);
        totalToCheck = totalAmountBN;
        const totalAmount = totalAmountBN.toString();
        setTotalAmount(getMaxDecimalsReadable(feeToken, totalAmount));
        const totalAmountFloat = parseFloat(totalAmount);
        if (feeToken.usdPrice) {
          setTotalAmountUSD(getAmountPrice(feeToken, totalAmountFloat, false));
        }
      } else if (amountUsdPrice) {
        const amountGasFeeUSDFloat = parseFloat(
          getAmountPrice(feeToken, gasFeesFloat, false),
        );
        const amountUSDFloat = parseFloat(amountUsdPrice);
        const totalUSDAmount = amountUSDFloat + amountGasFeeUSDFloat;
        setTotalAmountUSD(totalUSDAmount.toFixed(2));
      }

      if (totalToCheck.gt(Big(feeToken.amount.toString()))) {
        setTotalExceedsBalance(true);
      } else {
        setTotalExceedsBalance(false);
      }
    } else {
      setTotalExceedsBalance(true);
    }
  }, [gasFees]);

  useEffect(() => {
    const amountFloat = parseFloat(amount);
    erc20TokenBalanceSelected.usdPrice &&
      setAmountUsdPrice(
        getAmountPrice(erc20TokenBalanceSelected, amountFloat, false),
      );
  }, [amount, erc20TokenBalanceSelected]);

  const handleConfirmClick = async () => {
    console.log('erc20TokenBalanceSelected', erc20TokenBalanceSelected);

    console.log(currentAddress);
    console.log(address);
    console.log(amount);
    console.log(chainId);
    console.log('memo:', memo);

    let transfer;

    try {
      transfer = await createTransfer(
        currentAddress,
        address,
        amount,
        memo,
        chainId,
        erc20TokenBalanceSelected.instrumentAdmin,
        erc20TokenBalanceSelected.id,
      );
      console.log('transfer created:', transfer);
    } catch (error) {
      console.error('Error creating transfer:', error);
      toastr.error(translate('errorSendingTransaction'));
      return;
    }

    sendTransaction(
      currentAddress,
      transfer.command,
      transfer.preparedTx,
      transfer.disclosedContracts,
      gasFees.fee,
      chainId,
      selectedFeeToken,
    )
      .then((result) => {
        if (result) {
          toastr.success(translate('transactionSentSuccessfully'));
          getTransactions(
            currentAddress,
            erc20TokenBalanceSelected.instrumentAdmin,
            10,
            chainId,
            false,
            true,
          ).catch((err) => {
            console.error(
              `handleConfirmClick: error from getTransactions: ${err}`,
            );
          });
        } else {
          toastr.info(translate('transactionRejectedByUser'));
        }
      })
      .catch(() => {
        toastr.error(translate('errorSendingTransaction'));
      });
    closeModal && closeModal();
  };

  const totalAmountDisplay = () => {
    if (erc20TokenBalances.length > 0) {
      if (
        erc20TokenBalanceSelected.instrumentAdmin === feeToken.instrumentAdmin
      ) {
        return totalAmount + ` ${feeToken.symbol}`;
      } else {
        return (
          getHumanReadableAmount(erc20TokenBalanceSelected, amount) +
          ' ' +
          erc20TokenBalanceSelected.symbol +
          ' + ' +
          gasFeesAmount +
          ` ${feeToken.symbol}`
        );
      }
    }
  };

  return (
    <Modal>
      <Modal.Title>{translate('send')}</Modal.Title>
      <Modal.Body>
        <ToDiv>To</ToDiv>
        <AddressDiv>{shortenAddress(address)}</AddressDiv>
        <AssetQuantity
          currency={erc20TokenBalanceSelected.symbol}
          currencyValue={getMaxDecimalsReadable(
            erc20TokenBalanceSelected,
            amount,
          )}
          USDValue={amountUsdPrice}
          size="medium"
          centered
        />
        <Summary>
          <LeftSummary>
            <PopperTooltip
              placement="top"
              closeTrigger="hover"
              content={
                <EstimatedFeesTooltip>
                  {translate('gasFeesDefinition')}
                  <br></br>
                  <br></br>
                </EstimatedFeesTooltip>
              }
            >
              {translate('estimatedFee')}
            </PopperTooltip>
          </LeftSummary>
          <RightSummary>
            {isEstimatingGas && <LoadingWrapper />}
            {!isEstimatingGas && (
              <>
                <CurrencyAmount>
                  {gasFeesAmount} {selectedFeeToken}
                </CurrencyAmount>
                <USDAmount>{gasFeesAmountUSD} USD</USDAmount>
              </>
            )}
          </RightSummary>
        </Summary>

        <TotalAmount>
          {translate('maximumFees')} {gasFeesAmount} {selectedFeeToken}
        </TotalAmount>
        <Summary>
          <LeftSummary>
            <PopperTooltip
              placement="right"
              closeTrigger="hover"
              content="Amount + Fee"
            >
              {translate('total')}
            </PopperTooltip>
          </LeftSummary>
          <RightSummary>
            <CurrencyAmount>{totalAmountDisplay()}</CurrencyAmount>
            <USDAmount>{totalAmountUSD} USD</USDAmount>
          </RightSummary>
        </Summary>
        {totalAmount && (
          <TotalAmount>
            {translate('maximumAmount')} {totalAmount} {selectedFeeToken}
          </TotalAmount>
        )}
        {!isEstimatingGas && totalExceedsBalance && (
          <AlertTotalExceedsAmount
            text={translate('insufficientFundsForFees')}
            variant="warning"
          />
        )}
        <Summary>
          <LeftSummary>
            <PopperTooltip
              placement="right"
              closeTrigger="hover"
              content={memo}
            >
              Memo
            </PopperTooltip>
          </LeftSummary>
          <RightSummary>{memo ? memo : '—'}</RightSummary>
        </Summary>
      </Modal.Body>
      <Modal.Buttons>
        <ButtonStyled
          onClick={() => handleBack()}
          backgroundTransparent
          borderVisible
        >
          {translate('back').toUpperCase()}
        </ButtonStyled>
        <ButtonStyled
          enabled={!isEstimatingGas && !totalExceedsBalance}
          onClick={handleConfirmClick}
        >
          {translate('confirm')}
        </ButtonStyled>
      </Modal.Buttons>
    </Modal>
  );
};
